import options from './thing-details.component';
import AdvancedInformationComponent from './advanced-information';
import AlertBoxComponent from './alert-box';
import DetailsChartComponent from './details-chart';
import GeneralInformationComponent from './general-information';
import ThingLocation from './thing-location';
import ThingName from './thing-name';
import ThingDetailsLabels from './thing-details-labels';
import ThingDetailsFolder from './thing-details-folder';
import ThingDescription from './thing-description';
import NotesComponent from './notes';
import PermissionsComponent from './permissions';
import RecentEventsComponent from './recent-events';

const Component = {
    selector: 'dtThingDetails',
    options
};

export {
    Component,
    AdvancedInformationComponent,
    AlertBoxComponent,
    DetailsChartComponent,
    GeneralInformationComponent,
    ThingLocation,
    ThingDescription,
    NotesComponent,
    PermissionsComponent,
    RecentEventsComponent,
    ThingDetailsLabels,
    ThingDetailsFolder,
    ThingName
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/index.js